"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2749],{

/***/ 32749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jz": function() { return /* binding */ CZ_STATE_NAME; },
  "kd": function() { return /* binding */ POSITIONS; },
  "Zs": function() { return /* binding */ SK_STATE_NAME; },
  "PO": function() { return /* binding */ STATES; },
  "ZP": function() { return /* binding */ Register; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(26208);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/auth.service.ts
var auth_service = __webpack_require__(2586);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Register/Register.elements.tsx





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Registerelements__Wrapper",
  componentId: "sc-q27nz4-0"
})(["margin-top:", ";padding:0 ", ";display:flex;flex-direction:column;gap:", ";align-items:center;@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Registerelements__Title",
  componentId: "sc-q27nz4-1"
})(["display:block;padding-bottom:", ";font-weight:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(8), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
});
var Result = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Registerelements__Result",
  componentId: "sc-q27nz4-2"
})(["text-align:center;padding:", " 0;"], (0,polished_esm/* rem */.hO)(45));
var SuccessIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Registerelements__SuccessIcon",
  componentId: "sc-q27nz4-3"
})(["svg{path{fill:", ";stroke:", ";}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var SuccessMessage = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Registerelements__SuccessMessage",
  componentId: "sc-q27nz4-4"
})(["text-align:center;a{font-weight:", ";color:", ";cursor:pointer;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Registerelements__Label",
  componentId: "sc-q27nz4-5"
})(["display:block;padding-bottom:", ";font-weight:", ";font-size:", ";position:relative;"], (0,polished_esm/* rem */.hO)(8), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textBold;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.textBase;
});
var InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Registerelements__InputSection",
  componentId: "sc-q27nz4-6"
})(["position:relative;margin:0 auto;"]);
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Registerelements__Input",
  componentId: "sc-q27nz4-7"
})(["height:", ";padding:", " ", ";border:1px solid ", ";width:", ";border-radius:", ";", "}&.error{border-color:", ";}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(15), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(300), (0,polished_esm/* rem */.hO)(4), function (prop) {
  return prop.marginBottom ? "margin-bottom: ".concat((0,polished_esm/* rem */.hO)(prop.marginBottom), " !important") : '';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.danger;
});
var Select = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
  displayName: "Registerelements__Select",
  componentId: "sc-q27nz4-8"
})(["height:", ";border:", " solid ", ";outline:1px solid ", ";width:", ";color:", ";border-radius:", ";margin-bottom:", ";margin-top:", ";"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(12), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.white;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(300), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(4), function (props) {
  return props.bottom ? "".concat((0,polished_esm/* rem */.hO)(props.bottom)) : 0;
}, function (props) {
  return props.top ? "".concat((0,polished_esm/* rem */.hO)(props.top)) : 0;
});
var Option = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
  displayName: "Registerelements__Option",
  componentId: "sc-q27nz4-9"
})([""]);
var Error = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Registerelements__Error",
  componentId: "sc-q27nz4-10"
})(["color:", ";font-size:", ";position:absolute;left:0;bottom:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.danger;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSizes.textSmall;
}, function (props) {
  return props.bottom ? "-".concat((0,polished_esm/* rem */.hO)(props.bottom)) : "-".concat((0,polished_esm/* rem */.hO)(14));
});
var CheckboxLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Registerelements__CheckboxLabel",
  componentId: "sc-q27nz4-11"
})(["a{color:", ";text-decoration:none;}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.primary;
});
var Agreements = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Registerelements__Agreements",
  componentId: "sc-q27nz4-12"
})([""]);
var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Registerelements__Background",
  componentId: "sc-q27nz4-13"
})(["", ";width:100%;@media (min-width:", "px){width:", ";}input{margin:", " auto;}"], function (prop) {
  return prop.isActive ? "\n        display: flex;\n        flex-direction: column;\n        border: 1px solid ".concat(prop.theme.colors.border, ";\n        border-radius: ").concat((0,polished_esm/* rem */.hO)(16), ";\n        padding: ").concat((0,polished_esm/* rem */.hO)(10), ";\n        \n        @media (min-width: ").concat(theme/* breakpoints.sm */.A.sm, "px) {\n            padding: ").concat((0,polished_esm/* rem */.hO)(40), ";\n        }\n    ") : "".concat(prop.marginTop ? "margin-top: ".concat((0,polished_esm/* rem */.hO)(prop.marginTop)) : '');
}, theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(450), (0,polished_esm/* rem */.hO)(10));
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Registerelements__GlobalErrorMessage",
  componentId: "sc-q27nz4-14"
})(["color:", ";padding-top:", ";display:block;"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15));
// EXTERNAL MODULE: ./src/utils/validator.utils.ts
var validator_utils = __webpack_require__(53385);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Register/Register.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var POSITIONS = 'Advokát | Advokátsky koncipient | Asistent | Asistent audítora | Asistent daňového poradcu | Audítor | Bezpečnostný manažér | Daňový poradca | Dekan | Ekonóm | Ekonomický / Finančný riaditeľ | Exekútor | Exekútorský koncipient | Finančný controller | Finančný manažér | Finančný špecialista | Generálny riaditeľ | Hlavný účtovník | Inšpektor | IT Manažér | IT špecialista | Kontrolór | Krajský prokurátor | Lektor | Majiteľ | Manažér | Manažér kvality | Manažér logistiky | Marketingový manažér | Marketingový riaditeľ | Marketingový špecialista | Mzdový účtovník | Notár | Notársky koncipient | Obchodný manažér | Obchodný riaditeľ | Obchodný zástupca | Okresný prokurátor | Pedagóg | Personalista | Personálny konzultant | Personálny manažér | Personálny riaditeľ | Právnik firemné | Právnik štátny | Prednosta | Predseda | Predseda súdu | Prevádzkový manažér | Primátor | Prodekan | Produktový manažér | Programátor | Štátny zástupca | Prorektor | Referent, administratívny pracovník | Regionálny / Oblastný manažér | Rektor | Riaditeľ | Riaditeľ call centra | Riaditeľ IT | Riaditeľ kvality a ISO | Riaditeľ logistiky | Riaditeľ odboru | Riaditeľ pobočky | Riaditeľ správy súdu | Riaditeľ školy | Správca konkurznej podstaty | Starosta | Sudca | Špecialista bezpečnosti | Špecialista ochrany osobných údajov | Štatutár | Tajomník | Technický manažér | Technický riaditeľ | Technik | Účtovné | Vedúci | Vedúci ekonomického oddelenia | Vedúci právneho oddelenia | Výkonný riaditeľ | Výrobný riaditeľ | Vyšší súdny úradník | Zástupca riaditeľa | Živnostník / SZČO';
var CZ_STATE_NAME = 'Česká Republika';
var SK_STATE_NAME = 'Slovensko';
var STATES;

(function (STATES) {
  STATES["Slovensko"] = "SK";
  STATES["\u010Cesk\xE1 Republika"] = "CZ";
})(STATES || (STATES = {}));

var RegisterTemplate = function RegisterTemplate() {
  var _businessCountryInput5;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      isSent = _useState[0],
      setIsSent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isFailed = _useState3[0],
      setIsFailed = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isUserExist = _useState4[0],
      setIsUserExist = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      hasInvoiceDetails = _useState5[0],
      setHasInvoiceDetails = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      hasBillingDetails = _useState6[0],
      setHasBillingDetails = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      hasDeliveryDetails = _useState7[0],
      setHasDeliveryDetails = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      hasError = _useState8[0],
      setHasError = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      hasEmailError = _useState9[0],
      setHasEmailError = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      hasFirstNameError = _useState10[0],
      setHasFirstNameError = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      hasLastNameError = _useState11[0],
      setHasLastNameError = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      hasPhoneError = _useState12[0],
      setHasPhoneError = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      hasPasswordError = _useState13[0],
      setHasPasswordError = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      hasPasswordConfirmationError = _useState14[0],
      setHasPasswordConfirmationError = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      hasBusinessAddressError = _useState15[0],
      setHasBusinessAddressError = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      hasBusinessCityError = _useState16[0],
      setHasBusinessCityError = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      hasBusinessPostalCodeError = _useState17[0],
      setHasBusinessPostalCodeError = _useState17[1];

  var _useState18 = (0,react.useState)(false),
      hasBusinessCountryError = _useState18[0],
      setHasBusinessCountryError = _useState18[1];

  var _useState19 = (0,react.useState)(false),
      hasDeliveryFirstNameError = _useState19[0],
      setHasDeliveryFirstNameError = _useState19[1];

  var _useState20 = (0,react.useState)(false),
      hasDeliveryLastNameError = _useState20[0],
      setHasDeliveryLastNameError = _useState20[1];

  var _useState21 = (0,react.useState)(false),
      hasDeliveryPhoneError = _useState21[0],
      setHasDeliveryPhoneError = _useState21[1];

  var _useState22 = (0,react.useState)(false),
      hasDeliveryAddressError = _useState22[0],
      setHasDeliveryAddressError = _useState22[1];

  var _useState23 = (0,react.useState)(false),
      hasDeliveryCityError = _useState23[0],
      setHasDeliveryCityError = _useState23[1];

  var _useState24 = (0,react.useState)(false),
      hasDeliveryPostalCodeError = _useState24[0],
      setHasDeliveryPostalCodeError = _useState24[1];

  var _useState25 = (0,react.useState)(false),
      hasDeliveryCountryError = _useState25[0],
      setHasDeliveryCountryError = _useState25[1];

  var _useState26 = (0,react.useState)(false),
      hasBusinessNameError = _useState26[0],
      setHasBusinessNameError = _useState26[1];

  var _useState27 = (0,react.useState)(false),
      hasBusinessIdError = _useState27[0],
      setHasBusinessIdError = _useState27[1];

  var _useState28 = (0,react.useState)(false),
      hasBusinessVatIdError = _useState28[0],
      setHasBusinessVatIdError = _useState28[1];

  var _useState29 = (0,react.useState)(false),
      hasBusinessVatNoError = _useState29[0],
      setHasBusinessVatNoError = _useState29[1];

  var _useState30 = (0,react.useState)(false),
      isBusinessAgreementChecked = _useState30[0],
      setIsBusinessAgreementChecked = _useState30[1];

  var _useState31 = (0,react.useState)(false),
      isPersonallyAgreementChecked = _useState31[0],
      setIsPersonallyAgreementChecked = _useState31[1];

  var _useState32 = (0,react.useState)(false),
      isMarketingAgreementChecked = _useState32[0],
      setIsMarketingAgreementChecked = _useState32[1];

  var emailInputRef = (0,react.useRef)(null);
  var firstNameInputRef = (0,react.useRef)(null);
  var lastNameInputRef = (0,react.useRef)(null);
  var phoneInputRef = (0,react.useRef)(null);
  var positionInputRef = (0,react.useRef)(null);
  var passwordInputRef = (0,react.useRef)(null);
  var passwordConfirmationInputRef = (0,react.useRef)(null);
  var businessAddressInputRef = (0,react.useRef)(null);
  var businessPostalCodeInputRef = (0,react.useRef)(null);
  var businessCityInputRef = (0,react.useRef)(null);
  var businessCountryInputRef = (0,react.useRef)(null);
  var deliveryFirstNameInputRef = (0,react.useRef)(null);
  var deliveryLastNameInputRef = (0,react.useRef)(null);
  var deliveryCompanyInputRef = (0,react.useRef)(null);
  var deliveryPhoneInputRef = (0,react.useRef)(null);
  var deliveryAddressInputRef = (0,react.useRef)(null);
  var deliveryPostalCodeInputRef = (0,react.useRef)(null);
  var deliveryCityInputRef = (0,react.useRef)(null);
  var deliveryCountryInputRef = (0,react.useRef)(null);
  var businessNameInputRef = (0,react.useRef)(null);
  var businessIdInputRef = (0,react.useRef)(null);
  var businessVatIdInputRef = (0,react.useRef)(null);
  var businessVatNoInputRef = (0,react.useRef)(null);

  var emailValidation = function emailValidation(isSubmit) {
    var _emailInputRef$curren;

    setHasEmailError(false);

    if ((0,validator_utils/* hasIncorrectEmail */._I)(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value)) {
      setHasEmailError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var firstNameValidation = function firstNameValidation(isSubmit) {
    var _firstNameInputRef$cu;

    setHasFirstNameError(false);

    if ((firstNameInputRef === null || firstNameInputRef === void 0 ? void 0 : (_firstNameInputRef$cu = firstNameInputRef.current) === null || _firstNameInputRef$cu === void 0 ? void 0 : _firstNameInputRef$cu.value) === '') {
      setHasFirstNameError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var lastNameValidation = function lastNameValidation(isSubmit) {
    var _lastNameInputRef$cur;

    setHasLastNameError(false);

    if ((lastNameInputRef === null || lastNameInputRef === void 0 ? void 0 : (_lastNameInputRef$cur = lastNameInputRef.current) === null || _lastNameInputRef$cur === void 0 ? void 0 : _lastNameInputRef$cur.value) === '') {
      setHasLastNameError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var phoneValidation = function phoneValidation(isSubmit) {
    var _phoneInputRef$curren, _phoneInputRef$curren2, _phoneInputRef$curren3;

    setHasPhoneError(false);

    if ((phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) === '') {
      setHasPhoneError(true);
      if (isSubmit) setHasError(true);
      return true;
    } else if (phoneInputRef !== null && phoneInputRef !== void 0 && (_phoneInputRef$curren2 = phoneInputRef.current) !== null && _phoneInputRef$curren2 !== void 0 && _phoneInputRef$curren2.value && (0,validator_utils/* hasIncorrectPhone */.LX)(phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren3 = phoneInputRef.current) === null || _phoneInputRef$curren3 === void 0 ? void 0 : _phoneInputRef$curren3.value)) {
      setHasPhoneError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var passwordValidation = function passwordValidation(isSubmit) {
    var _passwordInputRef$cur, _passwordInputRef$cur2, _passwordInputRef$cur3;

    setHasPasswordError(false);

    if ((passwordInputRef === null || passwordInputRef === void 0 ? void 0 : (_passwordInputRef$cur = passwordInputRef.current) === null || _passwordInputRef$cur === void 0 ? void 0 : _passwordInputRef$cur.value) === '' || (passwordInputRef === null || passwordInputRef === void 0 ? void 0 : (_passwordInputRef$cur2 = passwordInputRef.current) === null || _passwordInputRef$cur2 === void 0 ? void 0 : (_passwordInputRef$cur3 = _passwordInputRef$cur2.value) === null || _passwordInputRef$cur3 === void 0 ? void 0 : _passwordInputRef$cur3.length) < constants/* MINIMUM_PASSWORD_LENGTH */.aM) {
      setHasPasswordError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var passwordRepeatValidation = function passwordRepeatValidation(isSubmit) {
    var _passwordInputRef$cur4, _passwordConfirmation;

    setHasPasswordConfirmationError(false);

    if ((passwordInputRef === null || passwordInputRef === void 0 ? void 0 : (_passwordInputRef$cur4 = passwordInputRef.current) === null || _passwordInputRef$cur4 === void 0 ? void 0 : _passwordInputRef$cur4.value) !== (passwordConfirmationInputRef === null || passwordConfirmationInputRef === void 0 ? void 0 : (_passwordConfirmation = passwordConfirmationInputRef.current) === null || _passwordConfirmation === void 0 ? void 0 : _passwordConfirmation.value)) {
      setHasPasswordConfirmationError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var businessAddressValidation = function businessAddressValidation(isSubmit) {
    var _businessAddressInput;

    setHasBusinessAddressError(false);

    if (hasInvoiceDetails && (businessAddressInputRef === null || businessAddressInputRef === void 0 ? void 0 : (_businessAddressInput = businessAddressInputRef.current) === null || _businessAddressInput === void 0 ? void 0 : _businessAddressInput.value) === '') {
      setHasBusinessAddressError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var businessCityValidation = function businessCityValidation(isSubmit) {
    var _businessCityInputRef;

    setHasBusinessCityError(false);

    if (hasInvoiceDetails && (businessCityInputRef === null || businessCityInputRef === void 0 ? void 0 : (_businessCityInputRef = businessCityInputRef.current) === null || _businessCityInputRef === void 0 ? void 0 : _businessCityInputRef.value) === '') {
      setHasBusinessCityError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var businessPostalCodeValidation = function businessPostalCodeValidation(isSubmit) {
    var _businessPostalCodeIn, _businessPostalCodeIn2, _businessPostalCodeIn3, _businessPostalCodeIn4;

    setHasBusinessPostalCodeError(false);

    if (hasInvoiceDetails && (businessPostalCodeInputRef === null || businessPostalCodeInputRef === void 0 ? void 0 : (_businessPostalCodeIn = businessPostalCodeInputRef.current) === null || _businessPostalCodeIn === void 0 ? void 0 : _businessPostalCodeIn.value) === '') {
      setHasBusinessPostalCodeError(true);
      if (isSubmit) setHasError(true);
      return true;
    } else if (hasInvoiceDetails && businessPostalCodeInputRef !== null && businessPostalCodeInputRef !== void 0 && (_businessPostalCodeIn2 = businessPostalCodeInputRef.current) !== null && _businessPostalCodeIn2 !== void 0 && _businessPostalCodeIn2.value && !(businessPostalCodeInputRef !== null && businessPostalCodeInputRef !== void 0 && (_businessPostalCodeIn3 = businessPostalCodeInputRef.current) !== null && _businessPostalCodeIn3 !== void 0 && (_businessPostalCodeIn4 = _businessPostalCodeIn3.value) !== null && _businessPostalCodeIn4 !== void 0 && _businessPostalCodeIn4.match(/^[0-9]{5}$/))) {
      setHasBusinessPostalCodeError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var businessNameCodeValidation = function businessNameCodeValidation(isSubmit) {
    var _businessNameInputRef;

    setHasBusinessNameError(false);

    if (hasBillingDetails && (businessNameInputRef === null || businessNameInputRef === void 0 ? void 0 : (_businessNameInputRef = businessNameInputRef.current) === null || _businessNameInputRef === void 0 ? void 0 : _businessNameInputRef.value) === '') {
      setHasBusinessNameError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var businessIdCodeValidation = function businessIdCodeValidation(isSubmit) {
    var _businessIdInputRef$c, _businessIdInputRef$c2, _businessIdInputRef$c3, _businessIdInputRef$c4;

    setHasBusinessIdError(false);

    if (hasBillingDetails && (businessIdInputRef === null || businessIdInputRef === void 0 ? void 0 : (_businessIdInputRef$c = businessIdInputRef.current) === null || _businessIdInputRef$c === void 0 ? void 0 : _businessIdInputRef$c.value) === '') {
      setHasBusinessIdError(true);
      if (isSubmit) setHasError(true);
      return true;
    } else if (hasBillingDetails && businessIdInputRef !== null && businessIdInputRef !== void 0 && (_businessIdInputRef$c2 = businessIdInputRef.current) !== null && _businessIdInputRef$c2 !== void 0 && _businessIdInputRef$c2.value && !(businessIdInputRef !== null && businessIdInputRef !== void 0 && (_businessIdInputRef$c3 = businessIdInputRef.current) !== null && _businessIdInputRef$c3 !== void 0 && (_businessIdInputRef$c4 = _businessIdInputRef$c3.value) !== null && _businessIdInputRef$c4 !== void 0 && _businessIdInputRef$c4.match(/^[0-9]{8}$/))) {
      setHasBusinessIdError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var businessVatIdCodeValidation = function businessVatIdCodeValidation(isSubmit) {
    var _businessCountryInput, _businessCountryInput2;

    setHasBusinessVatIdError(false);

    if ((businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput = businessCountryInputRef.current) === null || _businessCountryInput === void 0 ? void 0 : _businessCountryInput.value) === SK_STATE_NAME) {
      var _businessVatIdInputRe, _businessVatIdInputRe2, _businessVatIdInputRe3, _businessVatIdInputRe4;

      if (hasBillingDetails && (businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe = businessVatIdInputRef.current) === null || _businessVatIdInputRe === void 0 ? void 0 : _businessVatIdInputRe.value) === '') {
        setHasBusinessVatIdError(true);
        if (isSubmit) setHasError(true);
        return true;
      } else if (hasBillingDetails && businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe2 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe2 !== void 0 && _businessVatIdInputRe2.value && !(businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe3 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe3 !== void 0 && (_businessVatIdInputRe4 = _businessVatIdInputRe3.value) !== null && _businessVatIdInputRe4 !== void 0 && _businessVatIdInputRe4.match(/^[0-9]{10}$/))) {
        setHasBusinessVatIdError(true);
        if (isSubmit) setHasError(true);
        return true;
      }
    } else if ((businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput2 = businessCountryInputRef.current) === null || _businessCountryInput2 === void 0 ? void 0 : _businessCountryInput2.value) === CZ_STATE_NAME) {
      var _businessVatIdInputRe5, _businessVatIdInputRe6, _businessVatIdInputRe7, _businessVatIdInputRe8;

      if (hasBillingDetails && (businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe5 = businessVatIdInputRef.current) === null || _businessVatIdInputRe5 === void 0 ? void 0 : _businessVatIdInputRe5.value) === '') {
        setHasBusinessVatIdError(true);
        if (isSubmit) setHasError(true);
        return true;
      } else if (hasBillingDetails && businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe6 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe6 !== void 0 && _businessVatIdInputRe6.value && !(businessVatIdInputRef !== null && businessVatIdInputRef !== void 0 && (_businessVatIdInputRe7 = businessVatIdInputRef.current) !== null && _businessVatIdInputRe7 !== void 0 && (_businessVatIdInputRe8 = _businessVatIdInputRe7.value) !== null && _businessVatIdInputRe8 !== void 0 && _businessVatIdInputRe8.match(/^[A-Z]{2}[0-9]{8,10}$/))) {
        setHasBusinessVatIdError(true);
        if (isSubmit) setHasError(true);
        return true;
      }
    }

    return false;
  };

  var businessVatNoCodeValidation = function businessVatNoCodeValidation(isSubmit) {
    var _businessCountryInput3;

    setHasBusinessVatNoError(false);

    if ((businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput3 = businessCountryInputRef.current) === null || _businessCountryInput3 === void 0 ? void 0 : _businessCountryInput3.value) === SK_STATE_NAME) {
      var _businessVatNoInputRe, _businessVatNoInputRe2, _businessVatNoInputRe3, _businessVatNoInputRe4;

      if (hasBillingDetails && (businessVatNoInputRef === null || businessVatNoInputRef === void 0 ? void 0 : (_businessVatNoInputRe = businessVatNoInputRef.current) === null || _businessVatNoInputRe === void 0 ? void 0 : _businessVatNoInputRe.value) === '') {
        setHasBusinessVatNoError(true);
        if (isSubmit) setHasError(true);
        return true;
      } else if (hasBillingDetails && businessVatNoInputRef !== null && businessVatNoInputRef !== void 0 && (_businessVatNoInputRe2 = businessVatNoInputRef.current) !== null && _businessVatNoInputRe2 !== void 0 && _businessVatNoInputRe2.value && !(businessVatNoInputRef !== null && businessVatNoInputRef !== void 0 && (_businessVatNoInputRe3 = businessVatNoInputRef.current) !== null && _businessVatNoInputRe3 !== void 0 && (_businessVatNoInputRe4 = _businessVatNoInputRe3.value) !== null && _businessVatNoInputRe4 !== void 0 && _businessVatNoInputRe4.match(/^[A-Z]{2}[0-9]{10}$/))) {
        setHasBusinessVatNoError(true);
        if (isSubmit) setHasError(true);
        return true;
      }
    }

    return false;
  };

  var deliveryFirstNameValidation = function deliveryFirstNameValidation(isSubmit) {
    var _deliveryFirstNameInp;

    setHasDeliveryFirstNameError(false);

    if (hasDeliveryDetails && (deliveryFirstNameInputRef === null || deliveryFirstNameInputRef === void 0 ? void 0 : (_deliveryFirstNameInp = deliveryFirstNameInputRef.current) === null || _deliveryFirstNameInp === void 0 ? void 0 : _deliveryFirstNameInp.value) === '') {
      setHasDeliveryFirstNameError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var deliveryLastNameValidation = function deliveryLastNameValidation(isSubmit) {
    var _deliveryLastNameInpu;

    setHasDeliveryLastNameError(false);

    if (hasDeliveryDetails && (deliveryLastNameInputRef === null || deliveryLastNameInputRef === void 0 ? void 0 : (_deliveryLastNameInpu = deliveryLastNameInputRef.current) === null || _deliveryLastNameInpu === void 0 ? void 0 : _deliveryLastNameInpu.value) === '') {
      setHasDeliveryLastNameError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var deliveryPhoneValidation = function deliveryPhoneValidation(isSubmit) {
    var _deliveryPhoneInputRe, _deliveryPhoneInputRe2, _deliveryPhoneInputRe3;

    setHasDeliveryPhoneError(false);

    if (hasDeliveryDetails && (deliveryPhoneInputRef === null || deliveryPhoneInputRef === void 0 ? void 0 : (_deliveryPhoneInputRe = deliveryPhoneInputRef.current) === null || _deliveryPhoneInputRe === void 0 ? void 0 : _deliveryPhoneInputRe.value) === '') {
      setHasDeliveryPhoneError(true);
      if (isSubmit) setHasError(true);
      return true;
    } else if (hasDeliveryDetails && deliveryPhoneInputRef !== null && deliveryPhoneInputRef !== void 0 && (_deliveryPhoneInputRe2 = deliveryPhoneInputRef.current) !== null && _deliveryPhoneInputRe2 !== void 0 && _deliveryPhoneInputRe2.value && (0,validator_utils/* hasIncorrectPhone */.LX)(deliveryPhoneInputRef === null || deliveryPhoneInputRef === void 0 ? void 0 : (_deliveryPhoneInputRe3 = deliveryPhoneInputRef.current) === null || _deliveryPhoneInputRe3 === void 0 ? void 0 : _deliveryPhoneInputRe3.value)) {
      setHasDeliveryPhoneError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var deliveryAddressValidation = function deliveryAddressValidation(isSubmit) {
    var _deliveryAddressInput;

    setHasDeliveryAddressError(false);

    if (hasDeliveryDetails && (deliveryAddressInputRef === null || deliveryAddressInputRef === void 0 ? void 0 : (_deliveryAddressInput = deliveryAddressInputRef.current) === null || _deliveryAddressInput === void 0 ? void 0 : _deliveryAddressInput.value) === '') {
      setHasDeliveryAddressError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var deliveryCityValidation = function deliveryCityValidation(isSubmit) {
    var _deliveryCityInputRef;

    setHasDeliveryCityError(false);

    if (hasDeliveryDetails && (deliveryCityInputRef === null || deliveryCityInputRef === void 0 ? void 0 : (_deliveryCityInputRef = deliveryCityInputRef.current) === null || _deliveryCityInputRef === void 0 ? void 0 : _deliveryCityInputRef.value) === '') {
      setHasDeliveryCityError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var deliveryPostalCodeValidation = function deliveryPostalCodeValidation(isSubmit) {
    var _deliveryPostalCodeIn, _deliveryPostalCodeIn2, _deliveryPostalCodeIn3, _deliveryPostalCodeIn4;

    setHasDeliveryPostalCodeError(false);

    if (hasDeliveryDetails && (deliveryPostalCodeInputRef === null || deliveryPostalCodeInputRef === void 0 ? void 0 : (_deliveryPostalCodeIn = deliveryPostalCodeInputRef.current) === null || _deliveryPostalCodeIn === void 0 ? void 0 : _deliveryPostalCodeIn.value) === '') {
      setHasDeliveryPostalCodeError(true);
      if (isSubmit) setHasError(true);
      return true;
    } else if (hasDeliveryDetails && deliveryPostalCodeInputRef !== null && deliveryPostalCodeInputRef !== void 0 && (_deliveryPostalCodeIn2 = deliveryPostalCodeInputRef.current) !== null && _deliveryPostalCodeIn2 !== void 0 && _deliveryPostalCodeIn2.value && !(deliveryPostalCodeInputRef !== null && deliveryPostalCodeInputRef !== void 0 && (_deliveryPostalCodeIn3 = deliveryPostalCodeInputRef.current) !== null && _deliveryPostalCodeIn3 !== void 0 && (_deliveryPostalCodeIn4 = _deliveryPostalCodeIn3.value) !== null && _deliveryPostalCodeIn4 !== void 0 && _deliveryPostalCodeIn4.match(/^[0-9]{5}$/))) {
      setHasDeliveryPostalCodeError(true);
      if (isSubmit) setHasError(true);
      return true;
    }

    return false;
  };

  var handleSubmitClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var hasValidationError, _emailInputRef$curren2, _passwordInputRef$cur5, _firstNameInputRef$cu2, _lastNameInputRef$cur2, _phoneInputRef$curren4, _positionInputRef$cur, _positionInputRef$cur2, _positionInputRef$cur3, _businessAddressInput2, _businessCityInputRef2, _businessPostalCodeIn5, _businessCountryInput4, _businessNameInputRef2, _businessIdInputRef$c5, _businessVatIdInputRe9, _businessVatIdInputRe10, _businessVatNoInputRe5, _businessVatNoInputRe6, _deliveryFirstNameInp2, _deliveryLastNameInpu2, _deliveryPhoneInputRe4, _deliveryCompanyInput, _deliveryCompanyInput2, _deliveryAddressInput2, _deliveryCityInputRef2, _deliveryPostalCodeIn5, _deliveryCountryInput, _window, _window$fbq, _error$response;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasError(false);
              setIsFailed(false);
              setIsUserExist(false);
              setHasEmailError(false);
              setHasFirstNameError(false);
              setHasLastNameError(false);
              setHasPhoneError(false);
              setHasPasswordError(false);
              setHasPasswordConfirmationError(false);
              setHasBusinessAddressError(false);
              setHasBusinessCityError(false);
              setHasBusinessPostalCodeError(false);
              setHasBusinessCountryError(false);
              setHasBusinessNameError(false);
              setHasBusinessIdError(false);
              setHasBusinessVatIdError(false);
              setHasBusinessVatNoError(false);
              setHasDeliveryFirstNameError(false);
              setHasDeliveryLastNameError(false);
              setHasDeliveryPhoneError(false);
              setHasDeliveryAddressError(false);
              setHasDeliveryCityError(false);
              setHasDeliveryPostalCodeError(false);
              setHasDeliveryCountryError(false);
              hasValidationError = false;
              if (emailValidation(true)) hasValidationError = true;
              if (firstNameValidation(true)) hasValidationError = true;
              if (lastNameValidation(true)) hasValidationError = true;
              if (phoneValidation(true)) hasValidationError = true;
              if (passwordValidation(true)) hasValidationError = true;
              if (passwordRepeatValidation(true)) hasValidationError = true;
              if (businessAddressValidation(true)) hasValidationError = true;
              if (businessCityValidation(true)) hasValidationError = true;
              if (businessPostalCodeValidation(true)) hasValidationError = true;
              if (businessNameCodeValidation(true)) hasValidationError = true;
              if (businessIdCodeValidation(true)) hasValidationError = true;
              if (businessVatIdCodeValidation(true)) hasValidationError = true;
              if (businessVatNoCodeValidation(true)) hasValidationError = true;
              if (businessVatNoCodeValidation(true)) hasValidationError = true;
              if (deliveryFirstNameValidation(true)) hasValidationError = true;
              if (deliveryLastNameValidation(true)) hasValidationError = true;
              if (deliveryPhoneValidation(true)) hasValidationError = true;
              if (deliveryAddressValidation(true)) hasValidationError = true;
              if (deliveryCityValidation(true)) hasValidationError = true;
              if (deliveryPostalCodeValidation(true)) hasValidationError = true;

              if (!hasValidationError) {
                _context.next = 47;
                break;
              }

              return _context.abrupt("return");

            case 47:
              _context.prev = 47;
              setIsLoading(true);
              _context.next = 51;
              return auth_service/* authApi.register */.i.register(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value,
                password: passwordInputRef === null || passwordInputRef === void 0 ? void 0 : (_passwordInputRef$cur5 = passwordInputRef.current) === null || _passwordInputRef$cur5 === void 0 ? void 0 : _passwordInputRef$cur5.value,
                name: firstNameInputRef === null || firstNameInputRef === void 0 ? void 0 : (_firstNameInputRef$cu2 = firstNameInputRef.current) === null || _firstNameInputRef$cu2 === void 0 ? void 0 : _firstNameInputRef$cu2.value,
                surname: lastNameInputRef === null || lastNameInputRef === void 0 ? void 0 : (_lastNameInputRef$cur2 = lastNameInputRef.current) === null || _lastNameInputRef$cur2 === void 0 ? void 0 : _lastNameInputRef$cur2.value,
                phone_number: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren4 = phoneInputRef.current) === null || _phoneInputRef$curren4 === void 0 ? void 0 : _phoneInputRef$curren4.value
              }, (positionInputRef === null || positionInputRef === void 0 ? void 0 : (_positionInputRef$cur = positionInputRef.current) === null || _positionInputRef$cur === void 0 ? void 0 : _positionInputRef$cur.value) && POSITIONS.split('|').indexOf(positionInputRef === null || positionInputRef === void 0 ? void 0 : (_positionInputRef$cur2 = positionInputRef.current) === null || _positionInputRef$cur2 === void 0 ? void 0 : _positionInputRef$cur2.value) !== -1 && {
                position: POSITIONS.split('|').indexOf(positionInputRef === null || positionInputRef === void 0 ? void 0 : (_positionInputRef$cur3 = positionInputRef.current) === null || _positionInputRef$cur3 === void 0 ? void 0 : _positionInputRef$cur3.value)
              }), {}, {
                use_invoice_details: hasInvoiceDetails,
                marketing_agreement: isMarketingAgreementChecked
              }, hasInvoiceDetails && {
                invoice: {
                  street: businessAddressInputRef === null || businessAddressInputRef === void 0 ? void 0 : (_businessAddressInput2 = businessAddressInputRef.current) === null || _businessAddressInput2 === void 0 ? void 0 : _businessAddressInput2.value,
                  city: businessCityInputRef === null || businessCityInputRef === void 0 ? void 0 : (_businessCityInputRef2 = businessCityInputRef.current) === null || _businessCityInputRef2 === void 0 ? void 0 : _businessCityInputRef2.value,
                  zip_code: businessPostalCodeInputRef === null || businessPostalCodeInputRef === void 0 ? void 0 : (_businessPostalCodeIn5 = businessPostalCodeInputRef.current) === null || _businessPostalCodeIn5 === void 0 ? void 0 : _businessPostalCodeIn5.value,
                  state: STATES[businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput4 = businessCountryInputRef.current) === null || _businessCountryInput4 === void 0 ? void 0 : _businessCountryInput4.value]
                }
              }), {}, {
                use_company_details: hasBillingDetails
              }, hasBillingDetails && {
                company: _objectSpread(_objectSpread({
                  name: businessNameInputRef === null || businessNameInputRef === void 0 ? void 0 : (_businessNameInputRef2 = businessNameInputRef.current) === null || _businessNameInputRef2 === void 0 ? void 0 : _businessNameInputRef2.value,
                  business_id: businessIdInputRef === null || businessIdInputRef === void 0 ? void 0 : (_businessIdInputRef$c5 = businessIdInputRef.current) === null || _businessIdInputRef$c5 === void 0 ? void 0 : _businessIdInputRef$c5.value
                }, (businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe9 = businessVatIdInputRef.current) === null || _businessVatIdInputRe9 === void 0 ? void 0 : _businessVatIdInputRe9.value) !== '' && {
                  tax_id: businessVatIdInputRef === null || businessVatIdInputRef === void 0 ? void 0 : (_businessVatIdInputRe10 = businessVatIdInputRef.current) === null || _businessVatIdInputRe10 === void 0 ? void 0 : _businessVatIdInputRe10.value
                }), (businessVatNoInputRef === null || businessVatNoInputRef === void 0 ? void 0 : (_businessVatNoInputRe5 = businessVatNoInputRef.current) === null || _businessVatNoInputRe5 === void 0 ? void 0 : _businessVatNoInputRe5.value) !== '' && {
                  vat_no: businessVatNoInputRef === null || businessVatNoInputRef === void 0 ? void 0 : (_businessVatNoInputRe6 = businessVatNoInputRef.current) === null || _businessVatNoInputRe6 === void 0 ? void 0 : _businessVatNoInputRe6.value
                })
              }), {}, {
                use_delivery_address: hasDeliveryDetails
              }, hasDeliveryDetails && {
                delivery: _objectSpread(_objectSpread({
                  name: deliveryFirstNameInputRef === null || deliveryFirstNameInputRef === void 0 ? void 0 : (_deliveryFirstNameInp2 = deliveryFirstNameInputRef.current) === null || _deliveryFirstNameInp2 === void 0 ? void 0 : _deliveryFirstNameInp2.value,
                  surname: deliveryLastNameInputRef === null || deliveryLastNameInputRef === void 0 ? void 0 : (_deliveryLastNameInpu2 = deliveryLastNameInputRef.current) === null || _deliveryLastNameInpu2 === void 0 ? void 0 : _deliveryLastNameInpu2.value,
                  phone_number: deliveryPhoneInputRef === null || deliveryPhoneInputRef === void 0 ? void 0 : (_deliveryPhoneInputRe4 = deliveryPhoneInputRef.current) === null || _deliveryPhoneInputRe4 === void 0 ? void 0 : _deliveryPhoneInputRe4.value
                }, (deliveryCompanyInputRef === null || deliveryCompanyInputRef === void 0 ? void 0 : (_deliveryCompanyInput = deliveryCompanyInputRef.current) === null || _deliveryCompanyInput === void 0 ? void 0 : _deliveryCompanyInput.value) !== '' && {
                  company: deliveryCompanyInputRef === null || deliveryCompanyInputRef === void 0 ? void 0 : (_deliveryCompanyInput2 = deliveryCompanyInputRef.current) === null || _deliveryCompanyInput2 === void 0 ? void 0 : _deliveryCompanyInput2.value
                }), {}, {
                  street: deliveryAddressInputRef === null || deliveryAddressInputRef === void 0 ? void 0 : (_deliveryAddressInput2 = deliveryAddressInputRef.current) === null || _deliveryAddressInput2 === void 0 ? void 0 : _deliveryAddressInput2.value,
                  city: deliveryCityInputRef === null || deliveryCityInputRef === void 0 ? void 0 : (_deliveryCityInputRef2 = deliveryCityInputRef.current) === null || _deliveryCityInputRef2 === void 0 ? void 0 : _deliveryCityInputRef2.value,
                  zip_code: deliveryPostalCodeInputRef === null || deliveryPostalCodeInputRef === void 0 ? void 0 : (_deliveryPostalCodeIn5 = deliveryPostalCodeInputRef.current) === null || _deliveryPostalCodeIn5 === void 0 ? void 0 : _deliveryPostalCodeIn5.value,
                  state: STATES[deliveryCountryInputRef === null || deliveryCountryInputRef === void 0 ? void 0 : (_deliveryCountryInput = deliveryCountryInputRef.current) === null || _deliveryCountryInput === void 0 ? void 0 : _deliveryCountryInput.value]
                })
              }));

            case 51:
              (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', constants/* FBQ_EVENTS.COMPLETE_REGISTRATION */.PT.COMPLETE_REGISTRATION);
              setIsLoading(false);
              setIsSent(true);
              _context.next = 60;
              break;

            case 56:
              _context.prev = 56;
              _context.t0 = _context["catch"](47);
              setIsLoading(false);

              if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 409) {
                setIsUserExist(true);
              } else {
                setIsFailed(true);
              }

            case 60:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[47, 56]]);
    }));

    return function handleSubmitClick() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: isSent ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Result, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SuccessIcon, {
        name: Icon/* Icons.Send */.PJ.Send
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
        children: t('modal.register.alert.sent')
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [isFailed && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        type: Alert/* AlertTypes.error */.d.error,
        message: t('modal.register.alert.failed')
      }), isUserExist && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        type: Alert/* AlertTypes.error */.d.error,
        message: t('modal.register.alert.used')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: t('modal.register.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          className: hasEmailError ? 'error' : '',
          ref: emailInputRef,
          type: "email",
          name: "email",
          placeholder: "".concat(t('shop.input.mail'), "*"),
          onKeyUp: function onKeyUp() {
            return emailValidation();
          }
        }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
          children: t('modal.register.mail.error')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          className: hasFirstNameError ? 'error' : '',
          ref: firstNameInputRef,
          type: "firstName",
          name: "firstName",
          placeholder: "".concat(t('shop.input.firstName'), "*"),
          onKeyUp: function onKeyUp() {
            return firstNameValidation();
          }
        }), hasFirstNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
          children: t('modal.register.firstName.error')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          className: hasLastNameError ? 'error' : '',
          type: "lastName",
          name: "lastName",
          ref: lastNameInputRef,
          placeholder: "".concat(t('shop.input.lastName'), "*"),
          onKeyUp: function onKeyUp() {
            return lastNameValidation();
          }
        }), hasLastNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
          children: t('modal.register.lastName.error')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          className: hasPhoneError ? 'error' : '',
          type: "phone",
          name: "phone",
          ref: phoneInputRef,
          placeholder: "".concat(t('shop.input.phone'), "*"),
          onKeyUp: function onKeyUp() {
            return phoneValidation();
          }
        }), hasPhoneError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
          children: t('modal.register.phone.error')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Select, {
        ref: positionInputRef,
        name: "positions",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
          children: t('modal.register.position.placeholder')
        }), POSITIONS.split('|').map(function (value, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
            value: value,
            children: value
          }, key);
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          className: hasPasswordError ? 'error' : '',
          ref: passwordInputRef,
          type: "password",
          autoComplete: "off",
          placeholder: "".concat(t('shop.input.password'), "*"),
          onKeyUp: function onKeyUp() {
            return passwordValidation();
          }
        }), hasPasswordError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
          children: t('modal.register.password.error')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          className: hasPasswordConfirmationError ? 'error' : '',
          ref: passwordConfirmationInputRef,
          type: "password",
          placeholder: "".concat(t('shop.input.passwordConfirmation'), "*"),
          onKeyUp: function onKeyUp() {
            return passwordRepeatValidation();
          }
        }), hasPasswordConfirmationError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
          children: t('modal.register.passwordConfirmation.error')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
        isActive: hasInvoiceDetails,
        marginTop: 20,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          name: "invoice",
          checked: hasInvoiceDetails,
          onChange: function onChange() {
            return setHasInvoiceDetails(!hasInvoiceDetails);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxLabel, {
            dangerouslySetInnerHTML: {
              __html: t('modal.register.checkbox1')
            }
          })
        }), hasInvoiceDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasBusinessAddressError ? 'error' : '',
              ref: businessAddressInputRef,
              type: "address",
              name: "address",
              placeholder: "".concat(t('shop.input.address'), "*"),
              onKeyUp: function onKeyUp() {
                return businessAddressValidation();
              }
            }), hasBusinessAddressError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.address.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasBusinessCityError ? 'error' : '',
              type: "city",
              name: "city",
              ref: businessCityInputRef,
              placeholder: "".concat(t('shop.input.city'), "*"),
              onKeyUp: function onKeyUp() {
                return businessCityValidation();
              }
            }), hasBusinessCityError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.city.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasBusinessPostalCodeError ? 'error' : '',
              type: "postalCode",
              name: "postalCode",
              ref: businessPostalCodeInputRef,
              placeholder: "".concat(t('shop.input.postalCode'), "*"),
              onKeyUp: function onKeyUp() {
                return businessPostalCodeValidation();
              }
            }), hasBusinessPostalCodeError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.postalCode.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select, {
              bottom: 30,
              top: 10,
              ref: businessCountryInputRef,
              name: "businessCountry",
              children: Object.keys(STATES).map(function (value, key) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
                  value: value,
                  children: value
                }, key);
              })
            }), hasBusinessCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 2,
              children: t('modal.register.country.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
            name: "billing",
            checked: hasBillingDetails,
            onChange: function onChange() {
              return setHasBillingDetails(!hasBillingDetails);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxLabel, {
              dangerouslySetInnerHTML: {
                __html: t('modal.register.checkbox2')
              }
            })
          }), hasBillingDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessNameError ? 'error' : '',
                ref: businessNameInputRef,
                placeholder: "".concat(t('shop.input.company.name'), "*"),
                onKeyUp: function onKeyUp() {
                  return businessNameCodeValidation();
                }
              }), hasBusinessNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                bottom: 5,
                children: t('general.fillCorrectShape')
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessIdError ? 'error' : '',
                ref: businessIdInputRef,
                placeholder: "".concat(t('shop.input.company.id'), "*"),
                onKeyUp: function onKeyUp() {
                  return businessIdCodeValidation();
                }
              }), hasBusinessIdError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                bottom: 5,
                children: t('general.fillCorrectShape')
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessVatIdError ? 'error' : '',
                ref: businessVatIdInputRef,
                placeholder: "".concat(t('shop.input.company.vatId'), "*"),
                onKeyUp: function onKeyUp() {
                  return businessVatIdCodeValidation();
                }
              }), hasBusinessVatIdError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                bottom: 5,
                children: t('general.fillCorrectShape')
              })]
            }), (businessCountryInputRef === null || businessCountryInputRef === void 0 ? void 0 : (_businessCountryInput5 = businessCountryInputRef.current) === null || _businessCountryInput5 === void 0 ? void 0 : _businessCountryInput5.value) === SK_STATE_NAME && /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
                className: hasBusinessVatNoError ? 'error' : '',
                ref: businessVatNoInputRef,
                placeholder: "".concat(t('shop.input.company.vatNo'), "*"),
                onKeyUp: function onKeyUp() {
                  return businessVatNoCodeValidation();
                }
              }), hasBusinessVatNoError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
                bottom: 5,
                children: t('general.fillCorrectShape')
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
        isActive: hasDeliveryDetails,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          name: "company",
          checked: hasDeliveryDetails,
          onChange: function onChange() {
            return setHasDeliveryDetails(!hasDeliveryDetails);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxLabel, {
            dangerouslySetInnerHTML: {
              __html: t('modal.register.checkbox3')
            }
          })
        }), hasDeliveryDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasDeliveryFirstNameError ? 'error' : '',
              ref: deliveryFirstNameInputRef,
              type: "firstName",
              name: "firstName",
              placeholder: "".concat(t('shop.input.firstName'), "*"),
              onKeyUp: function onKeyUp() {
                return deliveryFirstNameValidation();
              }
            }), hasDeliveryFirstNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.firstName.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasDeliveryLastNameError ? 'error' : '',
              ref: deliveryLastNameInputRef,
              type: "lastName",
              name: "lastName",
              placeholder: "".concat(t('shop.input.lastName'), "*"),
              onKeyUp: function onKeyUp() {
                return deliveryLastNameValidation();
              }
            }), hasDeliveryLastNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.lastName.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputSection, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              ref: deliveryCompanyInputRef,
              placeholder: t('shop.input.company.name')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasDeliveryPhoneError ? 'error' : '',
              ref: deliveryPhoneInputRef,
              type: "phone",
              name: "phone",
              placeholder: "".concat(t('shop.input.phone'), "*"),
              onKeyUp: function onKeyUp() {
                return deliveryPhoneValidation();
              }
            }), hasDeliveryPhoneError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.phone.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasDeliveryAddressError ? 'error' : '',
              ref: deliveryAddressInputRef,
              type: "address",
              name: "address",
              placeholder: "".concat(t('shop.input.address'), "*"),
              onKeyUp: function onKeyUp() {
                return deliveryAddressValidation();
              }
            }), hasDeliveryAddressError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.address.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasDeliveryCityError ? 'error' : '',
              ref: deliveryCityInputRef,
              type: "city",
              name: "city",
              placeholder: "".concat(t('shop.input.city'), "*"),
              onKeyUp: function onKeyUp() {
                return deliveryCityValidation();
              }
            }), hasDeliveryCityError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.city.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
              className: hasDeliveryPostalCodeError ? 'error' : '',
              ref: deliveryPostalCodeInputRef,
              type: "postalCode",
              name: "postalCode",
              placeholder: "".concat(t('shop.input.postalCode'), "*"),
              onKeyUp: function onKeyUp() {
                return deliveryPostalCodeValidation();
              }
            }), hasDeliveryPostalCodeError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.postalCode.error')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select, {
              bottom: 30,
              top: 10,
              ref: deliveryCountryInputRef,
              name: "deliveryCountry",
              children: Object.keys(STATES).map(function (value, key) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
                  value: value,
                  children: value
                }, key);
              })
            }), hasDeliveryCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(Error, {
              bottom: 5,
              children: t('modal.register.country.error')
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Agreements, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          name: "bussiness",
          checked: isBusinessAgreementChecked,
          onChange: function onChange() {
            return setIsBusinessAgreementChecked(!isBusinessAgreementChecked);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckboxLabel, {
            children: ["S\xFAhlas\xEDm s", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              onClick: function onClick() {
                window.open(constants/* ROUTES.CONDITIONS */.Z6.CONDITIONS, '_blank');
                setIsBusinessAgreementChecked(!isBusinessAgreementChecked);
              },
              children: "obchodn\xFDmi podmienkami*"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          name: "personally",
          checked: isPersonallyAgreementChecked,
          onChange: function onChange() {
            return setIsPersonallyAgreementChecked(!isPersonallyAgreementChecked);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckboxLabel, {
            children: ["S\xFAhlas\xEDm so", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              onClick: function onClick() {
                window.open(constants/* ROUTES.GDPR */.Z6.GDPR, '_blank');
                setIsPersonallyAgreementChecked(!isPersonallyAgreementChecked);
              },
              children: "spracovan\xEDm osobn\xFDch \xFAdajov*"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          name: "marketing",
          checked: isMarketingAgreementChecked,
          onChange: function onChange() {
            return setIsMarketingAgreementChecked(!isMarketingAgreementChecked);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckboxLabel, {
            children: ["Chcem dost\xE1va\u0165 upozornenia na", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              onClick: function onClick() {
                window.open("".concat(constants/* ROUTES.GDPR */.Z6.GDPR, "#marketing"), '_blank');
                setIsMarketingAgreementChecked(!isMarketingAgreementChecked);
              },
              children: "novinky, z\u013Eavy a bonusy"
            })]
          })
        })]
      }), (hasEmailError || hasFirstNameError || hasLastNameError || hasPhoneError || hasPasswordError || hasPasswordConfirmationError || hasBusinessAddressError || hasBusinessCityError || hasBusinessPostalCodeError || hasBusinessCountryError || hasDeliveryFirstNameError || hasDeliveryLastNameError || hasDeliveryPhoneError || hasDeliveryAddressError || hasDeliveryCityError || hasDeliveryPostalCodeError || hasDeliveryCountryError || hasBusinessNameError || hasBusinessIdError || hasBusinessVatIdError || hasBusinessVatNoError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
        children: t('contact.form.error')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        isLoading: isLoading,
        onClick: handleSubmitClick,
        disabled: !isBusinessAgreementChecked || !isPersonallyAgreementChecked,
        text: t('modal.register.submit')
      })]
    })
  });
};

/* harmony default export */ var Register = (RegisterTemplate);

/***/ }),

/***/ 53385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LX": function() { return /* binding */ hasIncorrectPhone; },
/* harmony export */   "_I": function() { return /* binding */ hasIncorrectEmail; },
/* harmony export */   "bj": function() { return /* binding */ hasFirstNameOrLastNameContainsSpecialCharactersError; },
/* harmony export */   "ut": function() { return /* binding */ hasFirstNameOrLastNameMinimumLengthError; }
/* harmony export */ });
/* harmony import */ var _utils_cart_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80018);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40238);


var hasFirstNameOrLastNameMinimumLengthError = function hasFirstNameOrLastNameMinimumLengthError(str) {
  return str !== '' && str.length < 3;
};
var hasFirstNameOrLastNameContainsSpecialCharactersError = function hasFirstNameOrLastNameContainsSpecialCharactersError(str) {
  return str !== '' && (0,_utils_cart_utils__WEBPACK_IMPORTED_MODULE_0__/* .containsSpecialChars */ .Ip)(str);
};
var hasIncorrectEmail = function hasIncorrectEmail(str) {
  return str === '' || !_constants__WEBPACK_IMPORTED_MODULE_1__/* .EMAIL_REGEX.test */ .CU.test(str);
};
var hasIncorrectPhone = function hasIncorrectPhone(str) {
  return str === '' || !_constants__WEBPACK_IMPORTED_MODULE_1__/* .PHONE_REGEX.test */ ._D.test(str);
};

/***/ })

}]);